import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    width: "100%",
  },
  container: {
    height: "calc(100vh - 450px)",
  },
  button: {
    marginBottom: "16px",
  },
  rowHeader: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap"
  },
  colTitle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: 'center',
    flexWrap: "nowrap",
    width: '50%',
    paddingLeft: 5,
  },
  colButton: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: 'flex-end',
    width: '50%',
    paddingRight: 8,
    paddingTop: 25,
    paddingBottom: 25
  },
  headerTitle: {    
    fontSize: 16,    
    fontWeight: 700
  }
}));
